
(() => {
  class SideDrawer extends HTMLElement {
    connectedCallback() {
      this.classList.add('drawer', `drawer--${this.dataset.position || 'right'}`);
      this.panel = this.querySelector('.drawer__panel');
      this.setAttribute('aria-hidden', 'true');

      this.addEventListener('click', (e) => {
        if (e.target.closest('[data-drawer-close]') || e.target.hasAttribute('data-drawer-overlay')) {
          this.close();
        }
      });

      this.onKeydown = (e) => {
        if (e.key === 'Escape' && window.ThemeUtils.isTopLayer(this.panel || this)) this.close();
      };
    }

    get isOpen() { return this.classList.contains('drawer--open'); }

    open(trigger) {
      if (this.isOpen) return;
      this.triggerEl = trigger || null;
      this.classList.add('drawer--open');
      this.setAttribute('aria-hidden', 'false');
      trigger?.setAttribute('aria-expanded', 'true');
      window.ThemeUtils.lockScroll();
      document.addEventListener('keydown', this.onKeydown);

      window.ThemeUtils.trapFocus(this.panel || this);
      window.PubSub.publish(window.EVENTS.drawerOpen, { id: this.id });
    }

    close() {
      if (!this.isOpen) return;
      this.classList.remove('drawer--open');
      this.setAttribute('aria-hidden', 'true');
      this.triggerEl?.setAttribute('aria-expanded', 'false');
      window.ThemeUtils.releaseFocus(this.panel || this);
      window.ThemeUtils.unlockScroll();
      document.removeEventListener('keydown', this.onKeydown);
      window.PubSub.publish(window.EVENTS.drawerClose, { id: this.id });
    }

    disconnectedCallback() {
      if (this.isOpen) {
        window.ThemeUtils.releaseFocus(this.panel || this);
        window.ThemeUtils.unlockScroll();
        document.removeEventListener('keydown', this.onKeydown);
      }
    }
  }

  if (!customElements.get('side-drawer')) customElements.define('side-drawer', SideDrawer);

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-drawer-open]');
    if (!btn) return;
    e.preventDefault();
    document.getElementById(btn.dataset.drawerOpen)?.open?.(btn);
  });
})();
